import request from '@/utils/request'
let BASEROOT = '/visitor/v2'
export function loadLiveList(query) {//直播列表
    return request({
        url: BASEROOT + '/live/queryList',
        method: 'post',
        data: query
    })
}
export function loadActivityType(query){//获取活动或者直播类型 
    return request({
        url: BASEROOT + '/activityType/queryList',
        method: 'post',
        data: query
    })
}
export function loadLiveDetail(query){//获取直播详情
    return request({
        url: BASEROOT + '/live/queryDetail',
        method: 'post',
        data: query
    })
}
export function wantLive(query){//想看
    return request({
        url: BASEROOT + '/live/wantLive',
        method: 'post',
        data: query
    })
}
export function thumbUp(query){//想看
    return request({
        url: BASEROOT + '/live/thumbUp',
        method: 'post',
        data: query
    })
}
export function watchLog(query){//记录观看 人员
    return request({
        url: BASEROOT + '/live/watchLog',
        method: 'post',
        data: query
    })
}
export function checkLiveState(query){
    return request({
        url: BASEROOT + '/live/getLiveState',
        method: 'post',
        data: query
    })
}

// 交换名片
export function addVisitingCard(query){
    return request({
        url: BASEROOT + '/inviteRecord/addVisitingCard',
        method: 'post',
        data: query
    })
}
// 获取直播列表
export function queryList(query){
    return request({
        url: BASEROOT + '/liveMag/queryList',
        method: 'post',
        data: query
    })
}

// 获取展品
export function queryProduct(query){
    return request({
        url: BASEROOT + '/liveMag/queryProduct',
        method: 'post',
        data: query
    })
}

// 获取直播人
export function queryEmployees(query){
    return request({
        url: BASEROOT + '/liveMag/queryEmployees',
        method: 'post',
        data: query
    })
}

// 添加直播
export function liveAdd(query){
    return request({
        url: BASEROOT + '/liveMag/add',
        method: 'post',
        data: query
    })
}

// 修改直播
export function liveUpdate(query){
    return request({
        url: BASEROOT + '/liveMag/update',
        method: 'post',
        data: query
    })
}
// 获取OBS详细信息
export function queryObsDetail(query){
    return request({
        url: BASEROOT + '/liveMag/queryObsDetail',
        method: 'post',
        data: query
    })
}
// 获取userSig
export function getUserSig(query){
    return request({
        url: BASEROOT + '/live/getUserSig',
        method: 'post',
        data: query
    })
}


// 验证私密直播观看密码
export function validLivePassword(query){
    return request({
        url: BASEROOT + '/live/validLivePassword',
        method: 'post',
        data: query
    })
}

// 验证私密直播观看密码
export function showLogonQR(query){
    return request({
        url: BASEROOT + '/account/version3/showLogonQR',
        method: 'post',
        data: query
    })
}



